import i18n from '@/providers/i18n'

const maps = new Promise(resolve => {
  if (document.getElementById('google-maps-api') && typeof google !== 'undefined') {
    resolve(google);
  } else if (!document.getElementById('google-maps-api')) {
    var url =
      'https://maps.googleapis.com/maps/api/js' +
      '?key=' + ENV.MAPS_API_KEY +
      '&libraries=places,visualization'
    ;
    var js, fjs = document.getElementsByTagName('script')[0];
    js = document.createElement('script'); js.id = 'google-maps-api';
    js.src = url;
    fjs.parentNode.insertBefore(js, fjs);
    js.onreadystatechange = function () {
      if (js.readyState == 'complete') {
        resolve(google);
      }
    }
    js.onload = function () {
      resolve(google);
    }
  }
});

export default maps;

//Returns a map Proxy - actions can be future-applied before the map is initialized
//This function is meant to be bound to a component instance (use it with apply or call).
//Bound component must have a 'map' $ref, it can also have 'address' input $ref and/or 'geolocate' button $ref
export function create_map (options = {}, onPosition = null) {
  var resolve;
  const _map = new Proxy(
    {
      waitlist: [],
      map: false,
      wait: new Promise(r => {
        resolve = r;
      }),
      handler: function (obj, method) {
        //trap function
        return function () {
          obj.waitlist.push({
            method,
            args: Array.prototype.slice.call(arguments),
          });
        };
      },
    },
    {
      get: function (obj, prop) {
        if (obj.hasOwnProperty(prop)) {
          return obj[prop];
        }
        return obj.handler(obj, prop);
      },
      set: function (obj, prop, value) {
        if (obj.hasOwnProperty(prop)) {
          obj[prop] = value;
          return true;
        }
      }
    }
  );
  var gmap;
  maps.then(g => {
    var r = (opts) => {
      gmap = new g.maps.Map(this.$refs.map, opts);
      resolve(gmap);
      _map.map = gmap;
      _map.handler = function (obj, method) {
        return gmap[method];
      };
      for (let cb of _map.waitlist) {
        gmap[cb.method](...cb.args);
      }
    };
    if (this.$refs.address) {
      var searchBox = new g.maps.places.SearchBox(this.$refs.address);
      _map.addListener('bounds_changed', () => {
        searchBox.setBounds(_map.getBounds());
      });
      searchBox.addListener('places_changed', () => {
        var places = searchBox.getPlaces();
        if (!places.length) {
          return;
        }
        var position = places[0].geometry.location;
        if (onPosition) {
          onPosition(position);
        }
        _map.panTo(position);
      });
    }
    if (this.$refs.geolocate) {
      this.$refs.geolocate.addEventListener(
        'click',
        () =>
          detect_position(p => {
            if (onPosition) {
              onPosition(p);
            }
            _map.panTo(p);
          }),
        false
      );
    }
    if (onPosition) {
      _map.addListener('click', (cursor) => {
        onPosition(cursor.latLng);
      });
    }
    if (!options.hasOwnProperty('center')) {
      //try to get current coordinates
      var defaultOpts = {center: {lat: 46.05136, lng: 14.50625}, zoom: 6};
      return new Promise(resolve =>
          detect_position(center => {
            if (typeof center === 'object' && center.hasOwnProperty('lat')) {
              return resolve({
                center,
                zoom: 10,
              });
            } else {
              return resolve(defaultOpts);
            }
          }, false, defaultOpts.center)
        )
        .then(o => r(Object.assign({}, o, options)))
        .catch(o => r(Object.assign({}, o, defaultOpts)))
      ;
    } else {
      return r(options);
    }
  });
  return _map;
}

export function interactive_marker(map, icon, property = 'position') {
  var m = new google.maps.Marker({
    position: this[property],
    map,
    draggable: true,
    icon,
  });
  var updatepos = () => {
    if (!this[property]) {
      m.setVisible(false);
    } else {
      m.setVisible(true);
    }
    var mlat = m.position.lat();
    var mlng = m.position.lng();
    var plat = this[property].lat;
    var plng = this[property].lng;
    if (Math.abs(mlat - plat) > 0.001 || Math.abs(mlng - plng) > 0.001) {
      m.setPosition(this[property]);
      if (!map.getBounds().contains(this[property])) {
        map.setCenter(this[property]);
      }
    }
  };
  m.addListener('dragend', (cursor) => {
    this[property] = {
      lat: cursor.latLng.lat(),
      lng: cursor.latLng.lng(),
    };
  });
  this.$watch(property, updatepos);
  this.$watch(property + '.lat', updatepos);
  this.$watch(property + '.lng', updatepos);
  return m;
}

export function static_marker(opts, popupopts = false) {
  var m = new google.maps.Marker(opts);
  if (popupopts) {
    var popup = new google.maps.InfoWindow(popupopts);
    m.addListener('click', function() {
      popup.open(opts.map, m);
    });
    m.popup = popup;
  }
  return m;
}

export function detect_position (success, enableHighAccuracy = true, defaultvalue = null) {
  if (typeof navigator.geolocation === 'undefined') {
    var toast = document.toast(i18n.t('location.current_unavailable'), 'error');
    if (defaultvalue && typeof success === 'function') {
      return success(defaultvalue);
    }
    return toast;
  }
  navigator.geolocation.getCurrentPosition(pos => {
    if (typeof success === 'function') {
      success({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      });
    }
  },
  positionerror => {
    var toast;
    switch (positionerror.code) {
      case 1:
        toast = document.toast(i18n.t('location.current_rejected'), 'error');
        break;
      case 2:
      case 3:
      default:
        toast = document.toast(i18n.t('location.current_error'), 'error');
        break;
    }
    if (defaultvalue && typeof success === 'function') {
      return success(defaultvalue);
    }
    return toast;
  }, {
    enableHighAccuracy,
  });
}

export function reverse_address (position, geocoder = null, searchtype = null) {
  var gc;
  if (!window.geocoder_resolved_cache) {
    window.geocoder_resolved_cache = {};
  }
  if (geocoder) {
    gc = Promise.resolve(geocoder);
  } else {
    if (!window.geocoder_helper) {
      window.geocoder_helper = maps.then(g => new g.maps.Geocoder);
    }
    gc = window.geocoder_helper;
  }
  var latlngstr = String(position.lat) + ';' + String(position.lng);
  return gc
    .then(coder => {
      if (window.geocoder_resolved_cache.hasOwnProperty(latlngstr)) {
        return window.geocoder_resolved_cache[latlngstr];
      } else {
        return new Promise(resolve => {
          coder.geocode({location: {
            lat: parseFloat(position.lat),
            lng: parseFloat(position.lng),
          }}, (results, status) => {
            if (results && results[0]) {
              window.geocoder_resolved_cache[latlngstr] = results[0];
              var result = results[0];
              if (searchtype) {
                for (let component of result.address_components) {
                  if (component.types.includes(searchtype)) {
                    resolve(component);
                  }
                }
              }
              return resolve(result);
            }
          });
        });
      }
    })
  ;
}


// WEBPACK FOOTER //
// ./src/providers/maps.js